import { dark as muiLight } from "@material-ui/core/styles/createPalette";

let light = Object.assign(muiLight, { divider: "rgba(255, 255, 255, 0.45)" });

export default light;
